<iframe [src]="url$ | async" frameBorder="0">
  Loading...
</iframe>
